import { API_ENDPOINT } from '../config'
import { DEFAULT_SETTINGS } from '../controllers/settings'
import { getPlayerId, getPlayed } from '../controllers/stats'
import apiFetch from '../util/apiFetch'
import Box from './Box'
import Button from './Button'
import React, { FunctionComponent } from 'react'

type FeedbackBoxProps = {
	//
}

const FeedbackBox: FunctionComponent<FeedbackBoxProps> = () => {
	const [feedback, setFeedback] = React.useState('')
	const [feedbackSent, setFeedbackSent] = React.useState<boolean>(
		localStorage.getItem('feedbacksent') === 'true'
	)

	const sendFeedback = () => {
		if (!feedback) return
		const data = { pid: getPlayerId(), value: feedback, showClock: DEFAULT_SETTINGS.showclock }

		const url = `${API_ENDPOINT}/feedback`
		apiFetch(url, 'POST', data)
		setFeedbackSent(true)
		localStorage.setItem('feedbacksent', 'true')
	}

	// Don' display this unless the number of games played === 2
	if (getPlayed() !== 2) return null

	if (feedbackSent) {
		return (
			<Box>
				<h2>Thank you for the feedback!</h2>
			</Box>
		)
	}

	return (
		<Box>
			<h2>Thank you for playing!</h2>
			<p>
				Did you enjoy it? &nbsp; I&apos;d appreciate any feedback you can provide, positive
				or negative!
			</p>
			<textarea
				rows={10}
				value={feedback}
				onChange={e => setFeedback(e.currentTarget.value)}
				placeholder="Please pop your feedback in here and click the Send button. Thanks!"
			/>
			<Button onClick={sendFeedback}>Send</Button>
		</Box>
	)
}

export default FeedbackBox
